import Login from "../../../jsx/pages/Login";

const LoginWrapper = function (props) {
  return <Login />;
};

export default constore(LoginWrapper);
